import Image from 'next/image';
import { useCallback, useContext, useEffect, useState } from "react";
import { useRouter, usePathname } from 'next/navigation';
import { useRouter as useNextRouter } from 'next/router';
import { getProductList } from "../../pages/api/hello";
// import LayoutComponent from "../layout";
import { IProductList } from "../../@types/IProductList";
import { loadProductCategory } from "./api";
import { changeProductListUrl } from './utils';
import dynamic from 'next/dynamic';
import moment from 'moment';
const DynamicListProduct = dynamic(() => import('./List'));
const DynamicHeadComponent = dynamic(() => import('../layout/Head'));
const DynamicMenuSwitch = dynamic(() => import('../MenuSwitch'));
const DynamicFilterMobile = dynamic(() => import('../Filter/filter_mobile'));
const DynamicFilter = dynamic(() => import('../Filter'));
const DynamicLayoutComponent = dynamic(() => import('../layout'));
// import Filter from "../Filter";
import { checkUndefinedNumber } from '../../utils/format';
import { IBreadcrumbList, IImageObject, INewsArticle, IWebPage } from '../gSnippet/interface';
import { generateGSnippet } from '../gSnippet';
import environment from '../../utils/environment';
import { handleLinkCanonical } from '../../utils/utils';
import AppContext from '../../store/AppContext';
// import DescriptionTab from '../Tab/description_tab';
const DynamicDescriptionTab = dynamic(() => import('../Tab/description_tab'));

const Products: React.FC<IProductList> = ({ seo, typeProductsData, filterSetData, productGroupsData, activeTypeData, productsData, branchDatas }: any) => {
    const [loadingEnd, setLoadingEnd] = useState(true);
    const [loading, setLoading] = useState(false);
    const [origin, setOrigin] = useState("");
    const router = useRouter();
    const nextRouter = useNextRouter();
    const [openFilter, setOpenFilter] = useState(false);
    const [urlFilter, setUrlFilter] = useState(null);
    const [dataGroupProduct, setDataGroupProduct]: any = useState([]);
    const [branchs, setBranchs] = useState(branchDatas ?? []);
    const [groupTypeProductsData, setGroupTypeProductsData]:any = useState([]);
    // const [_seo, _setSeo] = useState(seo);
    const [content, setContent] = useState("");
    const [hasInnerText, setHasInnerText] = useState(true);
    const [hasCombo, setHasCombo] = useState(0);
    // const [showSuggestCombo, setShowSuggestCombo] = useState(false);
    const [headContent, setHeadContent]:any = useState(null);
    // const [hasHeadInnerText, setHasHeadInnerText] = useState(true);
    const { menus } = useContext(AppContext);
    const [linkCanonical, setLinkCanonical] = useState(null);
    let _defaultSetting = {
        page: 1,
        limit: 20, //(window.innerWidth < 768 ? 10 : 20),
        totalPages: 0,
        from_date: null,
        to_date: null,
        datas: null,
        filter: {},
        totalElements: 0
    }
    const [products, setProducts]: any = useState(_defaultSetting);

    const [filterSet, setFilterSet] = useState(filterSetData ?? []);
    const [groupCurrent, setGroupCurrent] = useState(null);
    function onChangeUrl(url: any) {
        router.push(origin + "/" + url);
    }
    async function onChangeActiveType(group_current:any) {

        // const urls = JSON.parse(localStorage.getItem("urls") ?? "");
        // let id = urls.find((e: any) => e.url === changeProductListUrl(nextRouter.asPath))?.id ?? '';
        // if (!id) {
        //     id = urlFilter
        // } else {
        //     localStorage.setItem("urlFilter", id?.toString());
        // }
        try{
            let page: any = 1;
            let url = nextRouter.asPath;
            if(url){
                let params:any = new URLSearchParams(window.location.search);
                const paramsObject = Object.fromEntries(params);
        
                if (paramsObject.page) {
                    page = Number(paramsObject.page);
                }
                let urlInput_Page= url.split('/page/');
                if(urlInput_Page && urlInput_Page.length > 1 && urlInput_Page[1]){
                    page = parseInt(urlInput_Page[1].split('?')[0]);
                    url = urlInput_Page[0];
                }
                
                let attr = paramsObject.attributes ? JSON.parse(decodeURIComponent(paramsObject.attributes.toString())) : null
                let branch_ids = paramsObject.branch_ids ? (decodeURIComponent(paramsObject.branch_ids.toString()).split(",").map(Number)) : null
                // setFilterSet(attr);
                let filter = {
                    group_url: changeProductListUrl(url),
                    attributes: attr,
                    from_rental_price: paramsObject.from_rental_price ? paramsObject.from_rental_price : 0,
                    to_rental_price: paramsObject.to_rental_price ? paramsObject.to_rental_price : 0,
                    from_price_sell: paramsObject.from_price_sell ? paramsObject.from_price_sell : 0,
                    to_price_sell: paramsObject.to_price_sell ? paramsObject.to_price_sell : 0,
                    check_stock: paramsObject.check_stock ? (paramsObject.check_stock.toString().toLocaleLowerCase() == "true") : false,
                    type: paramsObject.type ? paramsObject.type : null,
                    branch_ids: branch_ids,
                    search: paramsObject.search_value ? paramsObject.search_value : null,
                };
                let formatDate = "DD/MM/YYYY";
                let fromDate = paramsObject.fromDate ? moment(decodeURIComponent(paramsObject.fromDate.toString()), formatDate).format("DD/MM/YYYY HH:mm:ss") : null;
                let toDate = paramsObject.toDate ? moment(decodeURIComponent(paramsObject.toDate.toString()), formatDate).format("DD/MM/YYYY HH:mm:ss") : null;
                await loadProducts(filter, page, fromDate, toDate, products.limit, group_current);
               
                // await setUrlFilter(changeProductListUrl(url));//changeProductListUrl(nextRouter.asPath));
            }
        }catch(ex){
            alert("Không lấy được dữ liệu. Sẽ chuyển về trang chủ");
            router.push("/");
        }
    }

    async function onChangePage(page: number) {
        await loadProducts(products.filter, page, products.from_date, products.to_date);
    }

    async function loadProducts(filter?: any, page?: number, from_date?: any, to_date?: any, limit?: number, group_current:any = null) {
        try {
            await setContent("");
            await setHeadContent(null);
            setProducts(_defaultSetting);
            let gr_cur = (group_current ? group_current : groupCurrent);
            limit = limit ?? products.limit;
            filter = filter ?? products.filter;
            
            page = page ?? products.page;
            from_date = from_date ?? "";
            to_date = to_date ?? "";
            // setLoading(true);
            // setLoadingEnd(true);
            // setLoadedHead(true);
            let time = 0;
            if (filter?.group_url !== "" && filter?.group_url) {
                let type = "";
                if(filter.type){
                    type = "&type=0";
                    // setHasCombo(filter.type);
                }
                delete filter.type;

                // if(!nextRouter.query?.type || type == 0){
                //     let res_combo: any = await chkComboProductList(`limit=${limit}&page=${page}&from_date=${from_date}&to_date=${to_date}&type=${type}`, filter);
                //     if (res_combo) {
                //         if(res_combo.data == true){
                //             setShowSuggestCombo(true);
                //         }
                //         // setHasCombo(res_combo.data ? 1 : 0);
                //     }
                // }
                
                // if(nextRouter.query?.type){
                //     setShowSuggestCombo(true);
                // }
                
                let res: any = [];
                if(productsData && productsData.results && productsData.results.length > 0){
                    res = productsData;
                }else{
                    res = await getProductList(`limit=${limit}&page=${page}&from_date=${from_date}&to_date=${to_date}`+type, filter);
                }
                if (res) {
                    try{
                        // if(!seo.url_next && !seo.url_prev){
                        //     let seo_LinkCanonical:any = handleLinkCanonical(seo.url_root, (page ? page : 1), res.totalPages);
                        //     await setLinkCanonical(seo_LinkCanonical);
                        // }
                        if(gr_cur){
                            if(gr_cur?.head_content || gr_cur?.description){
                                await setHeadContent({
                                    head_content: gr_cur?.head_content,
                                    description: checkUndefinedNumber(page) > 1 ? null : gr_cur.description
                                });
                                time = time + 200;
                            }
                            setTimeout(function(){
                                setProducts({
                                    page: page,
                                    from_date: from_date,
                                    to_date: to_date,
                                    limit: limit,
                                    totalPages: res.totalPages,
                                    filter: filter,
                                    datas: res.results,
                                    totalElements: res.totalElements,
                                    typeCombo: type
                                });
                            }, (time));
                            
                            // setLoading(false);
                            

                            let arr_img:any = [];
                            if(res.results)
                            {
                                try{
                                    res.results.map((x:any) => x.file?.image_url).map((x:any)=> {
                                        if(x && (typeof x !== 'undefined')){
                                            arr_img.push(environment?.baseImageUrl + x);
                                        }
                                    });
                                }
                                catch(e){
                                    console.log(e);
                                }
                            }
                            await gSnippetLoad(gr_cur, arr_img);
                        }
                        
                        
                    }catch(e){
                        
                    }

                    // await setUrlFilter(filter?.group_url);
                    // localStorage.setItem("urlFilter", filter?.group_url.toString());
                }
            }
            
            setTimeout(function(){
                // setLoading(false);
                if(gr_cur && gr_cur.content){
                    setContent(gr_cur.content)
                }
                setTimeout(function(){
                    setLoadingEnd(false);
                }, (200));
            }, (300 + time));
            
        } catch (error) {
            setLoadingEnd(false);
            // setLoading(false);
        }
    }

    async function arrayProductData(array: Array<any>, arr_parent:any= [], level:number = 2) {
        let cloneArrayTypeProduct: any = structuredClone(array) ?? [];
        let position = level + 1;
        for(let index = 0; index < array.length; index++){
            let children = array[index].children ?? [];
            if (children.length > 0) {
                let child = [];
                let item_parent = {
                    id: array[index].id,
                    name: array[index].name,
                    url: array[index].url,
                    position: position,
                };
                //===== Xử lý gắn array parent vào child để lấy cho nhanh khi cần
                let _arr_parent = structuredClone(arr_parent) ?? [];
                _arr_parent.push(item_parent);
                children = await Promise.all(children.map(async(x:any) => {
                    return {
                        ...x,
                        parent: _arr_parent
                    };
                }));
                //===== Xử lý gắn array parent vào child để lấy cho nhanh khi cần
                child = await arrayProductData(children, _arr_parent, position);
                cloneArrayTypeProduct = await cloneArrayTypeProduct.concat(child);
            }
        }
        return cloneArrayTypeProduct;
    }

    const [gSnippet, setGSnippet] = useState(null);
    const router_path = usePathname();
    const gSnippetLoad = async (group_current:any, arr_img: Array<string>) => {
        try{
            let now = moment().toISOString();
            let webPage:IWebPage = {
            name: seo.title,
            description: seo.description,
            dateCreated: "",
            dateModified: "",
            primaryImageOfPage: "",
            keyword: seo.keyword
            }
            let imageObject:IImageObject = {};
            let newsArticle:INewsArticle = {};
            let _breadcrumb:Array<IBreadcrumbList> = [
                {
                    name: "Sản phẩm",
                    url: "/san-pham"
                }
            ];
            if(group_current){
                let image_url = (group_current.image?.file_url ? environment.baseImageUrl + group_current.image.file_url : null);
                group_current.parent?.map((x:any) => {
                    _breadcrumb.push(x);
                });

                if(group_current.url !== "/san-pham"){
                    _breadcrumb.push({
                        name: group_current.name,
                        url: group_current.url
                    });
                }else{
                    //==== Xử lý tĩnh gắn logo cho trang /san-pham
                    image_url = process.env.SITE_URL + group_current.image?.file_url
                }
        
                webPage.primaryImageOfPage = image_url;
                webPage.dateCreated = now;
                webPage.dateModified = now;
            
                imageObject = {
                    url_img: image_url,
                    caption: group_current.image?.name,
                }

                newsArticle = {
                    headline: group_current.name,
                    arr_image: arr_img,
                    description: seo.description,
                    dateCreated: group_current?.created_date ? group_current.created_date : now,
                    dateModified: group_current?.modified_date ? group_current.modified_date : now,
                }
            }
            let gSnippet = await generateGSnippet(router_path, webPage, imageObject, _breadcrumb, newsArticle);
            setGSnippet(gSnippet);
        }catch(e){
            console.log(e);
        }
    }

    async function loadProductCategoryData() {
        try {
            // setLoading(true);
            setLoadingEnd(true);
            if (menus.length > 0 && seo) // groupTypeProductsData && groupTypeProductsData.length == 0 && 
            {
                let arr_menu:any = await structuredClone(menus);
                let res:any = [];
                if(arr_menu?.length > 0 && arr_menu.find((x:any) => x.type==1)?.children){
                    res = arr_menu.find((x:any) => x.type==1)?.children;
                }
                else{
                    res = await loadProductCategory();
                }
                if (res) {
                    let data_nochild = await arrayProductData(res);
                    let urlInput_Page= nextRouter.asPath.split('?')[0].split('/page/');
                    let arr_url = urlInput_Page[0].split("/");
                    let group = arr_url[arr_url.length - 1];
                    // let group = (nextRouter.query.slug as Array<string>) ? (nextRouter.query.slug as Array<string>)[(nextRouter.query.slug as Array<string>)?.length - 1] : 0;
                    activeTypeData = urlInput_Page[0];//data_nochild?.find((e: any) => e.code === group)?.url ?? null;
                    let group_current = data_nochild?.find((e: any) => e.url === activeTypeData);
                    let page = 1;
                    if(urlInput_Page.length > 1 && urlInput_Page[1]){
                        page = parseInt(urlInput_Page[1].split('?')[0]);
                    }
                    
                    let _isAll = (!group_current && group == "san-pham");
                    if(_isAll){
                        activeTypeData = "/san-pham";
                        group_current = {
                            name: "Sản phẩm",
                            url: "/san-pham",
                            image: {
                                file_url: "asset/icon/logo.webp",
                                file_type: "png",
                                alt: "Sản phẩm"
                            }
                        }
                    }
                    
                    await setGroupTypeProductsData(res);
                    await setUrlFilter(activeTypeData);
                    await setDataGroupProduct(data_nochild);
                    await setGroupCurrent(group_current);
                    // if(seo && group_current.image){
                    //     _setSeo({
                    //         ...seo,
                    //         file: {
                    //             file_url: (_isAll ? process.env.SITE_URL : environment.baseImageUrl)  + group_current.image.file_url,
                    //             file_type: group_current.image.file_type,
                    //             alt: group_current.image.alt,
                    //         }
                    //     });
                    // }
                    
                    onChangeActiveType(group_current);
                    
                }
            } 
            // else {
            //     let group = (nextRouter.query.slug as Array<string>) ? (nextRouter.query.slug as Array<string>)[(nextRouter.query.slug as Array<string>)?.length - 1] : 0;
            //     activeTypeData = dataGroupProduct?.find((e: any) => e.code === group)?.url ?? null;
            //     // setUrlFilter(activeTypeData);
            // }

        } catch (error) {
            console.log(error);
        }
    }

    function onSearchFilter(filter: any, from_date: any, to_date: any) {
        filter.group_url = filter.group_url === "" ? products.filter?.group_url : (filter.group_url ?? products.filter?.group_url);
        loadProducts(filter, products.page, from_date, to_date)
    }

    function onOpenFilter() {
        setOpenFilter(!openFilter)
    }

    function isBottom(el: any) {
        try {
            return el?.getBoundingClientRect()?.bottom <= window.innerHeight;
        } catch (error) {
            return false
        }
    }

    const trackScrolling = useCallback(
        () => {
            const wrappedElement = document.getElementById('main');
            if (isBottom(wrappedElement)) {
                document.removeEventListener('scroll', trackScrolling);
                if (products.limit < products.totalElements) {
                    onScrollPaging();
                }
            }
        },
        [],
    )

    async function onScrollPaging() {
        let limit = products.limit + 10;
        if (limit < products.totalElements) {
            await loadProducts(products.filter, 1, products.from_date, products.to_date, limit);
        } else {
            limit = products.totalElements;
            await loadProducts(products.filter, 1, products.from_date, products.to_date, limit);
        }

    }

    // useEffect(() => {
    //     if (nextRouter.asPath !== " ") {
    //         onChangeActiveType();
    //     }
    // }, [nextRouter]);

    useEffect(() => {
        loadProductCategoryData();
    }, [seo, menus]);

    useEffect(() => {
        if (window.innerWidth < 728) {
            document.addEventListener('scroll', trackScrolling);
        }
        setOrigin(window?.location?.origin);
    }, []);

    useEffect(() => {
        document.querySelectorAll('.e-rte-image').forEach(($el:any) => {
            $el.style.maxHeight = ''; 
        });
    }, [headContent, content]);

    // useEffect(() => {
    //     let doc = document.getElementById("form_in_modal_group_content_rte-edit-view");
    //     if (doc) {
    //         doc.innerHTML = content ?? " ";
    //     }
    //     if (doc && (!doc.innerText || doc.innerText.trim() === "")) {
    //         if (content.indexOf("<img") < 0) {
    //             setHasInnerText(false);
    //         }
    //         // setHasInnerText(false);
    //     }
    // }, [urlFilter && content])

    // useEffect(() => {
    //     let doc = document.getElementById("form_in_modal_group_head_content_rte-edit-view");
    //     if (doc && headContent) {
    //         doc.innerHTML = headContent ?? " ";
    //     }
    //     if (doc && (!doc.innerText || doc.innerText.trim() === "")) {
    //         if (headContent.indexOf("<img") < 0) {
    //             setHasHeadInnerText(false);
    //         }
    //         // setHasInnerText(false);
    //     }
        
    // }, [urlFilter && headContent && nextRouter.query.page])

    async function loadCombo(){
        let combo = (hasCombo == 1 ? 0 : 1);
        router.push(window.location.pathname + "?&type=" + combo);
        // await loadProducts(products.filter, 1, products.from_date, products.to_date, products.limit, isCombo);
    }

    const loadToolKit = () => {
        return  <div onClick={() => onOpenFilter()} id="btn-filter-product" className="content hidden border-top lg:flex">
                    <Image
                        loading="lazy"
                        src="/asset/icon/ico_two_tone.svg"
                        alt="filter"
                        width={24}
                        height={24}
                    />
                    <p>Lọc</p>
                    <div className="support_popup" >
                        <div className="content">Lọc sản phẩm</div>
                    </div>
                </div>
    }

    return <>
        <DynamicHeadComponent gSnippet={gSnippet} seo={seo} linkCanonical={linkCanonical}/>
        <DynamicLayoutComponent
            props={{
                id: "main"
            }}
            isLoading={loading}
            loadingEnd={loadingEnd}
            componentToolkit={loadToolKit()}>
                {
                    urlFilter && <DynamicMenuSwitch groupTypeProductsData={groupTypeProductsData} activeId={urlFilter} arrayData={dataGroupProduct} setActiveId={onChangeUrl} />
                }

                {headContent && (headContent.head_content || headContent.description) ? <div className='wrap-product-detail mt-product-detail'>
                    {
                        headContent.head_content ? 
                            <DynamicDescriptionTab content={headContent.head_content ?? ""} key={"contentTab"} hidden={false}/>
                            : <></>
                    }
                    {
                        headContent.description ? 
                            <DynamicDescriptionTab content={headContent.description ?? ""} key={"contentTab"} hidden={false}/>
                            : <></>
                    }
                </div> : <></>}
                
                {products?.datas?.length == 0 ? <div className="mb-[100px] flex w-full justify-center">
                    <Image
                        className="relative"
                        src={"/asset/image/search_not_found.webp"}
                        alt="not_found_search"
                        fill
                        objectFit='cover'
                    />
                </div> : products?.datas?.length > 0  ? <DynamicListProduct
                isLoading={false}
                onChangePage={onChangePage}
                products={products}
                branchs={branchs}
                onIncreaseLimit={onScrollPaging} /> : <></>}
            
            
            
            {urlFilter ? (content && hasInnerText) && <div className='wrap-product-detail'>
                    <DynamicDescriptionTab content={content ?? ""} key={"contentTab"} hidden={false}/>
                </div> : <div></div>}
        </DynamicLayoutComponent>
        

       
        {/* {showSuggestCombo && <LightBuld /> } */}
        {/* {openSignUp && <PopupSignup id={isOpen.id} setOpen={setOpenSignUp} additionalFunc={additionalFunc} />} */}
        
        {openFilter && <DynamicFilter
            activeTypeData={urlFilter}
            onOpenFilter={onOpenFilter}
            onSearch={onSearchFilter}
            productGroupData={groupTypeProductsData}
            filterSetData={filterSet}
            typeCombo={hasCombo}
        />}
        <>
            {!openFilter && <div className="lg:hidden bg-white z-[11] fixed bottom-0 w-full shadow flex flex-row gap-4 items-center h-[60px] px-5">
                <button id="btn-filter-product-mobile" onClick={() => { onOpenFilter() }} className="w-full bg-[#006D75] rounded-md border-[1px] border-[#bfbfbf] py-[8px] flex items-center justify-center text-sm text-[#fff] h-[2.75rem] flex flex-row gap-2">
                    <Image
                        loading="lazy"
                        className="rotate-[90deg]"
                        src="/asset/icon/ico_two_tone.svg"
                        alt="filter"
                        width={16}
                        height={16}
                    />
                    Lọc
                </button>
            </div>}

            {openFilter && <DynamicFilterMobile
                activeTypeData={urlFilter}
                openFilter={openFilter}
                onOpenFilter={onOpenFilter}
                onSearch={onSearchFilter}
                productGroupData={groupTypeProductsData}
                filterSetData={filterSet}
                typeCombo={hasCombo}
            />}
        </>

        {/* {isOpen.isOpen && <PopupOrder
            is_purchase={isOpen.is_purchase}
            isOpen={isOpen.isOpen}
            setIsOpen={closePopup}
            id={isOpen?.id}
            orderDate={date}
            orderType={isOpen.orderType}
            branchs={branchs} isOthers={true} />}
        <LoadingComponent loading={isLoading} /> */}

    </>
}

export default Products